import React, { useEffect, useState } from "react";
import styles from "./BetaGearPopup.module.css";
import { useTranslation } from "react-i18next";

const BetaGearPopup = ({ isOpen, onClose }) => {
  const { t } = useTranslation();
  const [autoOpen, setAutoOpen] = useState(false);

  useEffect(() => {
    const hasSeenBeta = localStorage.getItem("beta_gear_popup_seen");
    if (!hasSeenBeta) {
      setAutoOpen(true);
    }
  }, []);

  const handleAcknowledge = () => {
    localStorage.setItem("beta_gear_popup_seen", "true");
    setAutoOpen(false);
    if (onClose) onClose();
  };

  if (!autoOpen && !isOpen) return null;

  return (
    <div className={styles.overlay}>
      <div className={styles.popup}>
        <div className={styles.icon}>🧪</div>
        <h2 className={styles.title}>Beta Version</h2>
        <p className={styles.message} style={{ marginBottom: "12px", fontWeight: "600" }}>
          Welcome to the new Gear section!
        </p>
        <p className={styles.message} style={{ fontSize: "0.95rem", textAlign: "left", marginBottom: "16px" }}>
          Welcome to the new Gear page! You can compare products and see real-time pricing. Watchlisted products' prices can be tracked through email, you can set this up in your account settings. You can also set the currency of display, but prices shown like this are just estimates. Please note that some prices might be outdated and some links may not work as expected. We are doing our best to solve this, but external webshop product feeds can be unpredictable. Always double-check prices and availability on the retailer's website before making a purchase.
        </p>
        <p className={styles.message} style={{ fontSize: "0.95rem", textAlign: "left", marginBottom: "24px" }}>
          Most product links provided are affiliate links, using them helps the site stay active and updated frequently. Gear related features are in beta mode, feedback is very welcome while we improve them (you can give anonymous feedback, look at the bottom of any page)!
        </p>

        <button className={styles.closeButton} onClick={handleAcknowledge}>
          {t('action.understand', 'I Understand')}
        </button>
      </div>
    </div>
  );
};

export default BetaGearPopup;
